import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import React from "react";
import MoreFromUsLogo from "./more-from-us-logo/more-from-us-logo";
import data from "./more-from-us.data.json";
import styles from "./more-from-us.module.scss";

function MoreFromUs() {
  return (
    <div className={styles["more-from-us"]}>
      <Accordion label="More from us">
        <div className="util-grid">
          {data.map(el => (
            <div key={el.id} className={styles["more-from-us__element"]}>
              <a className={styles["more-from-us__element-img"]}>
                <MoreFromUsLogo element={el.id} />
              </a>
              <p>{el.text}</p>
              <a href={el.linkUrl} target="_blank" rel="noopener noreferrer">
                {el.linkText}
              </a>
            </div>
          ))}
        </div>
      </Accordion>
    </div>
  );
}

export default MoreFromUs;
